/**
 * external dependencies
 */
import { TabulatorFull, Options, CellComponent } from 'tabulator-tables';

/**
 * internal dependencies
 */
import { IndividualTransaction } from '../../../models/transactions.interface';
import { formatDate } from '../../../helpers/helpers';

export const displayDashboardTransactions = ( data: IndividualTransaction[], element: HTMLElement ) => {
  /**
   * Formats the link button displayed.
   * 
   * @param {CellComponent} cell the cell component
   * 
   * @returns the link button
   */
  const link_button = (cell: CellComponent, formatterParams: any) => {
    const { txnId, timeStampReq } = cell.getData() as IndividualTransaction;
    const date = formatDate(timeStampReq);

    return `<a class='aafp_btn-table btn_theme-primary f' 
              href='/transactions/transaction-individual/?transactionID=${txnId}' 
              data-toggle="tooltip" 
              data-placement="bottom" 
              title="View transaction for ${date}">
                <i class="far fa-eye"></i>
            </a>`;
  }

  /**
   * Formats the date displayed.
   * 
   * @param {CellComponent} cell the cell component
   * 
   * @returns the formatted date
   */
  function table_format_date(cell: CellComponent, formatterParams: any) {
    const { timeStampReq } = cell.getData() as IndividualTransaction;
    return formatDate(timeStampReq);
  }

  /**
   * Formats the dispenser displayed.
   * 
   * @param {CellComponent} cell the cell component
   * 
   * @returns the formatted dispenser
   */
  const format_dispenser = (cell: CellComponent, formatterParams: any) => {
    const { terminalId, terminalName } = cell.getData() as IndividualTransaction;

    if (terminalId === terminalName) {
      return terminalName;
    } else {
      return `${terminalId} - ${terminalName}`;
    }
  }

  const options: Options = {
    index:"ID",
    data: data,
    placeholder: "No Data Available",
    pagination:true,
    paginationMode: "local",
    paginationSize: 10,
    paginationSizeSelector: [25, 50, 100],
    paginationCounter: "rows",
    minHeight: "100px",
    selectableRows: false,
    initialSort: [{ column: 'timeStampReq', dir: 'desc' }],
    columns: [
      { title: "ID", field:"ID", visible:false},
      { title: "Date", field: "timeStampReq", formatter: table_format_date, sorter: "string", resizable: false, vertAlign: 'middle' },
      { title: "Gallons", field: "deliveredGallons", sorter: "string", resizable: false, vertAlign: 'middle' },
      { title: "Terminal", field: "terminalName", formatter: format_dispenser,  sorter: "string", resizable: false, vertAlign: 'middle' },
      { title: '', field: "LinkButton", formatter: link_button, cssClass: "aafp_column-button", hozAlign: 'center', headerSort: false, resizable: false }
    ]
  };

  const transTableGrid = new TabulatorFull(element, options);
}